import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ArticalsService } from '../articals.service';

@Component({
  selector: 'app-artical',
  templateUrl: './artical.component.html',
  styleUrls: ['./artical.component.scss']
})
export class ArticalComponent implements OnInit {
  articalDetails;
  suggestArtical = [];
  path: string;
  artical;
  poll;
  isVoted: boolean = false;
  pollForm: FormGroup;
  haveLogin: boolean;
  isPollTime: boolean;

  constructor(
    private articalsService: ArticalsService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private gobalFunctionService: GobalFunctionService
  ) {
    this.pollForm = this.fb.group({
      selectedChoice: ['', Validators.required],
    })
  }

  ngOnInit(): void {
    this.path = window.location.origin + '/';
    this.route.params.pipe(
      switchMap(params => {
        return this.articalsService.getDetailByArticalID(params['articalId']);
      }),
      switchMap(artical => {
        let i: number = 0
        let lastIndex: number = null;
        let ran: number;
        let timeNow = new Date();
        let pollEndDate = new Date(artical.result.DETAIL_POLL[0]?.POLL_END);

        this.artical = artical.result.DETAIL_ARTICAL[0];
        this.poll = artical.result.DETAIL_POLL[0];
        this.haveLogin = artical.result.HAVE_LOGIN;
        pollEndDate = new Date(new Date(pollEndDate.setDate(pollEndDate.getDate() + 1)).setHours(0, 0, 0));

        this.isPollTime = new Date(this.poll?.POLL_START) < timeNow && pollEndDate > timeNow;

        this.articalDetails = this.sanitizer.bypassSecurityTrustHtml(artical.result.DETAIL_ARTICAL[0].ARTICAL_DETAIL);
        // // console.log(artical.result);
        // // console.log(this.haveLogin);

        while (i !== 2 && artical.result.SUGGEST_ARTICAL.length > 0) {
          ran = Math.floor(Math.random() * artical.result.SUGGEST_ARTICAL.length);
          if (!lastIndex) {
            this.suggestArtical[i] = artical.result.SUGGEST_ARTICAL[ran];
            lastIndex = ran;
            i++;
          } else if (lastIndex !== ran) {
            this.suggestArtical[i] = artical.result.SUGGEST_ARTICAL[ran];
            i++;
          }
        }
        this.suggestArtical = artical.result.SUGGEST_ARTICAL;
        this.gobalFunctionService.setSEO(this.artical.ARTICAL_TITAL, 'article', this.artical.ARTICAL_DETAIL, this.artical.ARTICAL_PIC);

        return this.articalsService.readArticalById(this.artical.ARTICAL_ID);
      })
    ).subscribe()
  }

  openLogin() {
    this.router.navigate(['login'], { state: { redirect: this.router.url } })
  }

  vote(p) {
    // // console.log(p);
    this.articalsService.votePoll(this.poll.POLL_ID, p.selectedChoice).subscribe(res => {
      if (res.success) {
        this.isVoted = true;
      }
    }, err => {
      alert(err.error.message)
    })
  }

  viewSuggest(path) {
    this.router.navigate(['/article/' + path])
      .then(() => {
        window.location.reload();
      });
  }
}
